import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/correios/:id',
  title: 'Pedido',
  endpoint: '/app/purchase',
  breadcrumbs: [],
}
